import { futurIAOggiFixture } from "./fixtures/futur-ia-oggi";

export type PriorityStatus = "Da ieri" | "Da fare" | "In corso" | "Completata";
export type PriorityTask = {
  id: string;
  title: string;
  client: string;
  context: string;
  duration: string;
  due: string;
  status: PriorityStatus;
};
export type FuturIAEmail = {
  id: string;
  sender: string;
  initials: string;
  subject: string;
  preview: string;
  time: string;
  folder: "Interne" | "Altre";
};
export type TodayEvent = {
  id: string;
  title: string;
  start: string;
  end: string;
  kind: "Call" | "Riunione";
  detail?: string;
};
export type FuturIAOggiData = {
  unreadInternalEmails: number;
  yesterdayTasks: number;
  availableHours: number;
  suggestion: string;
  priorities: PriorityTask[];
  emails: FuturIAEmail[];
  events: TodayEvent[];
  freeTime: { start: string; end: string; label: string };
};
export type AssistantMessage = { id: string; role: "user" | "assistant"; content: string };
export type OggiPreview = "available" | "empty" | "error";

const delay = (ms = 280) => new Promise<void>((resolve) => window.setTimeout(resolve, ms));
const priorities = futurIAOggiFixture.priorities.map((task) => ({ ...task }));

function copyData(): FuturIAOggiData {
  return {
    ...futurIAOggiFixture,
    priorities: priorities.map((task) => ({ ...task })),
    emails: futurIAOggiFixture.emails.map((email) => ({ ...email })),
    events: futurIAOggiFixture.events.map((event) => ({ ...event })),
    freeTime: { ...futurIAOggiFixture.freeTime },
  };
}

export async function getFuturIAOggi(preview: OggiPreview = "available"): Promise<FuturIAOggiData> {
  await delay();
  if (preview === "error") throw new Error("I dati demo di Oggi non sono disponibili.");
  if (preview === "empty") return { ...copyData(), priorities: [], emails: [], events: [] };
  return copyData();
}

export async function updatePriorityTask(id: string, completed: boolean): Promise<PriorityTask> {
  await delay(180);
  const task = priorities.find((item) => item.id === id);
  if (!task) throw new Error("Attività demo non trovata.");
  task.status = completed ? "Completata" : "Da fare";
  return { ...task };
}

export async function sendFuturIAAssistantMessage(content: string): Promise<AssistantMessage> {
  await delay(620);
  const text = content.trim();
  if (!text) throw new Error("Scrivi una richiesta prima di inviare.");
  if (text.toLocaleLowerCase("it").includes("errore")) throw new Error("La risposta demo non è disponibile. Puoi riprovare.");
  return {
    id: `futur-ia-reply-${Date.now()}`,
    role: "assistant",
    content: `Ho annotato la richiesta “${text}”. Questa è un’anteprima dimostrativa: nessuna email o attività è stata inviata o modificata.`,
  };
}
